import { useScheduleFetch } from '../hooks/useScheduleFetch';
export function ScheduleFetch({ render, actions }) {
    const schedules = useScheduleFetch(actions);
    return render(schedules);
}
